<template>
  <div class="screen" ref="inner">
    <slot></slot>
  </div>
</template>

<script>
  import breakpoints, { viewNames, breakpointNames } from '@/ulils/responsive.breakpoints'
  import anime from 'animejs'

  export default {
    computed: {
      isFinal () {
        if (!this.$store.state.questions) return
        return this.step >= this.$store.state.questions.length
      },
      animation () {
        return this.$store.state.animation
      },
      step () {
        return this.$store.state.current
      },
      durations () {
        return this.$store.state.durations
      },
      view () {
        return this.$store.getters.view
      },
      offset () {
        const responsive = this.responsive
        const { vw } = responsive
        const scaleBreakpoint = breakpoints[breakpointNames.SCALE]
        const originalWidth = { [viewNames.FULL]: 1440, [viewNames.COMPACT]: 475 }[this.$store.getters.view]
        const isScalableBreakpoint = vw >= scaleBreakpoint[0] && vw <= scaleBreakpoint[1]
        let ratio = isScalableBreakpoint ? vw / originalWidth : 1

        const {
          screen,
          offset
        } = {
          [viewNames.FULL]: { screen: 900 * ratio, offset: 1080 * ratio },
          [viewNames.COMPACT]: { screen: 667, offset: 805 }
        }[this.view]
        const currentScreen = responsive.vh
        const isDesktopFinal = this.isFinal && this.view === viewNames.FULL
        const gap = isDesktopFinal ? 0 : screen > currentScreen ? (screen - currentScreen) / 2 : 0

        const step = this.step === null ? 0 : this.step + 1
        const pos = (step * offset) + gap
        return pos
      }
    },
    watch: {
      'responsive.vh' () {
        this.scroll({ offset: this.offset, duration: 500 })
      },
      durations () {
        this.drive()
      }
    },
    methods: {
      tune () {
        const el = document.querySelector('.car')
        const screen = document.querySelector('.screen')
        const { top } = el.getBoundingClientRect()

        const tune = !this.isFinal
          ? (this.responsive.breakpoint === breakpointNames.TABLET)
            ? window.innerHeight * -0.25
            : window.innerHeight * -0.12
          : window.innerHeight * -0.5


        this.scroll({
          offset: top + screen.scrollTop + tune,
          duration: 1000,
        })
      },
      drive () {
        this.scroll({
          offset: this.offset,
          duration: this.$store.getters.duration,
          delay: this.view === viewNames.COMPACT ? !this.step ? 0 : 300 : 0,
          busy: true
        }).then(() => {
          if (
            this.view === viewNames.COMPACT &&
            this.step !== null &&
            !this.isFinal
          ) {
            this.tune()
          }
        })
      },
      scroll ({ offset, duration, delay = 0, busy }) {
        if (busy !== undefined) this.$store.commit('busy', !!busy)
        return anime({
          targets: this.$refs.inner,
          easing: 'easeInOutQuad',
          scrollTop: offset,
          duration: duration === undefined ? this.animation.duration : duration,
          delay,
        }).finished.then(() => {
          if (busy !== undefined) this.$store.commit('busy', !busy)
        })
      },
    }
  }
</script>

<style lang="scss">
  .screen {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }
</style>
